/**
 * Support code for sections/cm-product-accordions.liquid.
 *
 * 1. Exclusive-open fallback. Modern browsers close sibling <details> for us
 *    via the shared `name` attribute, so this only does the work where that
 *    isn't supported yet.
 * 2. Wires the description's "size guide" link to the existing Size guide
 *    popup button, so the single size chart stays the one source.
 */
(function () {
  if (window.__cmAccordionsInit) return;
  window.__cmAccordionsInit = true;

  var supportsExclusiveDetails = 'name' in document.createElement('details');

  function initExclusiveFallback() {
    if (supportsExclusiveDetails) return;
    document.querySelectorAll('.cm-accordions').forEach(function (group) {
      var items = group.querySelectorAll('.cm-accordions__item');
      items.forEach(function (item) {
        if (item.dataset.cmExclusive) return;
        item.dataset.cmExclusive = '1';
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function initSizeGuideLinks() {
    document.querySelectorAll('[data-cm-size-guide]').forEach(function (link) {
      if (link.dataset.cmReady) return;
      link.dataset.cmReady = '1';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var button = document.querySelector('.popup-link__button');
        if (button) button.click();
      });
    });
  }

  function init() {
    initExclusiveFallback();
    initSizeGuideLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
